/* eslint-disable no-restricted-globals */
import { useCallback } from 'react'
import { toast } from '@bounty/creators-design-system'
import { useAuthState } from '../useAuth'
import { API_URL } from '../../config/env'
import { logger } from '../../utils/logger'

export const LOCALSTORAGE_TIKTOK_OAUTH_REDIRECT_URL = 'tikTokOauthRedirectURL'

export const useTikTok = () => {
  const { isAuthed, token } = useAuthState()

  const loginWithTikTok = useCallback(() => {
    if (isAuthed === false) {
      logger.error('Cannot login with TikTok if the user is not authenticated!')
      return
    }
    window.location.assign(`${API_URL}/auth/oauth-tik-tok-init?token=${token}`)
  }, [isAuthed, token])

  const handleTikTokLoginResponse = useCallback(() => {
    const params = new URLSearchParams(window.location.search)
    const result = params.get('result')
    const message = params.get('message')

    if (result !== 'success') {
      logger.warn('TikTok failed, try again!', message)
      toast.error({
        message: message ?? '',
        title: 'TikTok auth error!',
      })
      return { redirectUrl: '/verify-tiktok' }
    }

    const redirectUrl = localStorage.getItem(
      LOCALSTORAGE_TIKTOK_OAUTH_REDIRECT_URL,
    )

    localStorage.removeItem(LOCALSTORAGE_TIKTOK_OAUTH_REDIRECT_URL)
    return { redirectUrl: redirectUrl ?? '/' }
  }, [])

  return {
    loginWithTikTok,
    handleTikTokLoginResponse,
    isLoading: false,
    setIsLoading: () => logger.log('Only used for native oauth!'),
  }
}
